export { default } from './ScriptingContainer';
